<template>
  <el-dialog
    title="修改密码"
    :visible.sync="resetPassDialogFormVisible"
    :show="show"
    @close="$emit('update:show', false)"
    class="resetpassDialog"
    append-to-body
  >
    <el-form :model="creatFrom" ref="creatFrom" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="用户名"
            :label-width="formLabelWidth"
            prop="username"
          >
            <el-input v-model="creatFrom.username" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="旧密码"
            :label-width="formLabelWidth"
            prop="oldPass"
          >
            <el-input
              @paste.native.capture.prevent="handleFalse"
              @copy.native.capture.prevent="handleFalse"
              @cut.native.capture.prevent="handleFalse"
              v-model="creatFrom.oldPass"
              type="password"
              show-password
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="新密码"
            :label-width="formLabelWidth"
            prop="pass"
          >
            <el-input
              @paste.native.capture.prevent="handleFalse"
              @copy.native.capture.prevent="handleFalse"
              @cut.native.capture.prevent="handleFalse"
              v-model="creatFrom.pass"
              type="password"
              show-password
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="确认密码"
            :label-width="formLabelWidth"
            prop="rePass"
          >
            <el-input
              @paste.native.capture.prevent="handleFalse"
              @copy.native.capture.prevent="handleFalse"
              @cut.native.capture.prevent="handleFalse"
              v-model="creatFrom.rePass"
              type="password"
              show-password
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="text-align: center; padding-top: 20px">
        <el-button type="primary" @click="resetPass()">确认修改</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import "../../../assets/css/dialog.css";
export default {
  name: "resetPassDialog",
  data() {
    const rulesNewPassword = (rule, value, callback) => {
      var regex = new RegExp(
        "^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9])[\\da-zA-Z`~!@#$%^&*()-_=+{};:,<.>/?|]{8,16}$"
      );
      if (!regex.test(value)) {
        callback(
          new Error(
            "密码必须为8~16位，大写+小写+特殊字符+数字，密码不能包含中文及中文字符"
          )
        );
      } else {
        callback();
      }
    };
    const equalToPassword = (rule, value, callback) => {
      if (this.creatFrom.pass !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      formLabelWidth: "120px",
      resetPassDialogFormVisible: null,
      creatFrom: {
        username: JSON.parse(sessionStorage.getItem("userInfo")).username,
        oldPass: "",
        pass: "",
        rePass: "",
      },

      rules: {
        oldPass: [{ required: true, message: "请填写旧密码", trigger: "blur" }],
        pass: [
          { required: true, message: "请填写新密码", trigger: "blur" },
          // { required: true, validator: rulesNewPassword, trigger: "blur" }等保三级
        ],
        rePass: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" },
        ],
      },
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    userIfo: String,
  },
  beforeUpdate() {
    this.creatFrom.username = JSON.parse(
      sessionStorage.getItem("userInfo")
    ).username;
  },
  watch: {
    show() {
      if (this.resetPassDialogFormVisible === false) {
        this.$refs.creatFrom.resetFields();
      } else {
        // 等保三级
        //   this.$http.get('/locationbs/captchaImage').then((data) => {
        //     sessionStorage.setItem("encryptEnabled", data.data.encryptEnabled)
        // })
      }
      this.resetPassDialogFormVisible = this.show;
    },
  },
  methods: {
    handleFalse() {
      return false;
    },
    resetPass() {
      this.$refs["creatFrom"].validate((valid) => {
        if (valid) {
          if (
            this.creatFrom.pass === null ||
            this.creatFrom.rePass === null ||
            this.creatFrom.pass === "" ||
            this.creatFrom.rePass === ""
          ) {
            this.$alert("新密码不能为空，请重新输入", "输入有误", {
              confirmButtonText: "确定",
            });
          } else if (this.creatFrom.pass !== this.creatFrom.rePass) {
            this.$alert("两次输入密码不相同，请重新输入", "输入有误", {
              confirmButtonText: "确定",
            });
          } else {
            this.$accountFun.updatePass(
              this,
              "/locationbs/sys/user/updatePass"
            );
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.resetpassDialog /deep/ .el-dialog__header {
  line-height: 30px;
  padding: 10px 20px !important;
}
.resetpassDialog /deep/ .el-dialog__headerbtn {
  top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/accountDialogDir/resetPassDialog.vue